import { memo, useState } from 'react';
import { Iframe } from '@alf/uikit';
import { Loader, STREAM_PLAYER_TYPE, VideoPlayer } from '@namespace/common';
import { useDeviceStore } from '@namespace/device';
import { useTrackFavTv } from '../../../hooks/useTrackFavTv';
import { PlayerWrapper, StreamError } from './components';

import styles from './index.module.css';

export const StreamBare = ({
  isReady,
  streamUrl,
  streamPlayerType,
  errorMessage,
  eventId,
  restrictSize
}) => {
  const { isMobileDevice } = useDeviceStore();
  const [playerError, setPlayerError] = useState(null);

  // TODO How should we track this? It's not favtv only now!
  useTrackFavTv({
    eventId,
    isValidStream: !errorMessage && Boolean(streamUrl)
  });

  if (!isReady) {
    return <Loader />;
  }

  // errorMessage is the ONLY indication of error. If not - go fix useVideoStream()!
  // However, if somehow streamUrl is nil - avoid crash and show generic stream error.
  if (errorMessage || playerError || !streamUrl) {
    return (
      <StreamError
        streamUrl={streamUrl}
        errorMessage={errorMessage}
        playerError={playerError}
      />
    );
  }

  if (streamPlayerType === STREAM_PLAYER_TYPE.PLAYER) {
    let restrictionProps;
    if (restrictSize && !isMobileDevice) {
      restrictionProps = {
        allowFullScreen: false,
        disablePictureInPicture: true,
        disableRemotePlayback: true,
        className: styles.restrictedPlayerSize
      };
    }

    return (
      <PlayerWrapper dataRole="event-stream">
        <VideoPlayer
          streamUrl={streamUrl}
          {...restrictionProps}
          setError={setPlayerError}
        />
      </PlayerWrapper>
    );
  }

  if (streamPlayerType === STREAM_PLAYER_TYPE.IFRAME) {
    return (
      <PlayerWrapper>
        <Iframe
          title="steam-iframe"
          src={streamUrl}
          className={styles.iframePlayer}
          allowFullScreen={true}
        />
      </PlayerWrapper>
    );
  }

  return null;
};

export const Stream = memo(StreamBare);
